import React from 'react'
import { css } from '@emotion/react'
import { Wantedly } from './icons/Wantedly'
import { FacebookIcon, TwitterIcon } from '@/components/atoms/SocialIcon'

type Props = {
  facebook?: string | null
  twitter?: string | null
  wantedly?: string | null
  color?: string
  iconSize?: number
  className?: string
}

export const SNSLinks: React.FC<Props> = (props) => {
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        color: ${props.color};
      `}
      className={props.className}
    >
      {props.twitter && (
        <a
          href={props.twitter}
          target="_blank"
          css={css`
            margin-right: 1rem;
          `}
        >
          <TwitterIcon
            css={css`
              color: ${props.color};
            `}
            size={props.iconSize}
          />
        </a>
      )}
      {props.facebook && (
        <a
          href={props.facebook}
          target="_blank"
          css={css`
            margin-right: 1rem;
          `}
        >
          <FacebookIcon
            css={css`
              color: ${props.color};
            `}
            size={props.iconSize}
          />
        </a>
      )}
      {props.wantedly && (
        <a href={props.wantedly} target="_blank">
          <Wantedly color={props.color} size={props.iconSize} />
        </a>
      )}
    </div>
  )
}
